module.exports = __webpack_public_path__ + "static/img/23.b6cf775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/23.png
// module id = Z262
// module chunks = 0